import { render } from "./BirthdayInfos.vue?vue&type=template&id=5624616a&scoped=true"
import script from "./BirthdayInfos.vue?vue&type=script&lang=js"
export * from "./BirthdayInfos.vue?vue&type=script&lang=js"

import "./BirthdayInfos.vue?vue&type=style&index=0&id=5624616a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5624616a"]])

export default __exports__